// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"2b5540f2","72":"d8896f53","487":"de672560","503":"8d812268","541":"4a900ac2","559":"396ca927","769":"4b1cde11"}[chunkId] + ".chunk.js";
};